/**
 * Store Deliveries Repository Implementation — Data Layer (Clean Architecture).
 * Uses DataSource and mappers; returns domain models.
 */

import {StoreDeliveriesRepository, StoreDeliveriesTimelineResult} from './StoreDeliveriesRepository';
import {StoreDeliveriesAPIDataSource} from '../api/StoreDeliveriesAPIDataSource';
import {mapTimelineResponseToModel, mapTransactionResponseToModel} from '../mappers/storeDeliveries.mapper';
import {StoreDeliveryTransaction, StoreDeliveryFilters} from '../models/storeDeliveries.model';
import {AppError} from '../../../Data/config/AppError';

export class StoreDeliveriesRepositoryImpl implements StoreDeliveriesRepository {
  async getTimeline(storeId: string, filters: StoreDeliveryFilters): Promise<StoreDeliveriesTimelineResult> {
    try {
      const response = await StoreDeliveriesAPIDataSource.getTimeline(storeId, filters);
      return mapTimelineResponseToModel(response);
    } catch (error) {
      throw AppError.fromApiError(error);
    }
  }

  async getTransaction(transactionId: string): Promise<StoreDeliveryTransaction> {
    try {
      const response = await StoreDeliveriesAPIDataSource.getTransaction(transactionId);
      return mapTransactionResponseToModel(response);
    } catch (error) {
      throw AppError.fromApiError(error);
    }
  }
}
